import { Box, Button, Tooltip } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";

const LoadMoreButton = ({ remaining, isPending, onLoadMore, onShowAll }) => {
  if (!remaining) return null;

  return (
    <Box sx={{ display: "flex", justifyContent: "center", gap: 1, mt: 2, mb: 1 }}>
      <Button
        variant="outlined"
        color="primary"
        onClick={onLoadMore}
        disabled={isPending}
      >
        {isPending ? "Зареждане..." : `Покажи още (${remaining})`}
      </Button>

      <Tooltip title={`Зареждането на всички ${remaining} записа наведнъж може да забави страницата.`}>
        <span>
          <Button
            variant="outlined"
            color="warning"
            startIcon={<WarningAmberIcon />}
            onClick={onShowAll}
            disabled={isPending}
          >
            Покажи всички
          </Button>
        </span>
      </Tooltip>
    </Box>
  );
};

export default LoadMoreButton;
